/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { FilterOperator } from '../models/filter-operator';
export interface QueryExpression {
  contextual?: boolean | null;
  field?: string | null;
  operator?: FilterOperator;
  values?: Array<any> | null;
}

export class QueryExpression {
  contextual?: boolean | null;
  field?: string | null;
  operator?: FilterOperator;
  values?: any[] | null;

  constructor(value: QueryExpression) {
    this.contextual = value?.contextual;
    this.field = value?.field;
    this.operator = value?.operator ? Object.entries(Object.values(FilterOperator)).flatMap((x) => x).find(x => x === value.operator) as FilterOperator : undefined;
    this.values = value?.values;
  }
}
